<div class="filter-option">
  <div class="lum-label">{{ label }}</div>

  <mat-form-field
    [ngClass]="{ 'filter-option-inline': inlineChips }"
    class="filter-option__chip-list w-100"
    appearance="outline"
  >
    <mat-chip-list #chipList aria-label="Option selection">
      <mat-chip *ngFor="let order of selectedOrders" class="lum-chip">
        <div class="filter-option__chip-list-label">
          {{ order?.label }}
        </div>
        <button matChipRemove (click)="onRemove(order.value)">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
      <input
        class="filter-option__input"
        placeholder="Search Sales Order..."
        #filterInput
        [formControl]="inputControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      />
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option
        *ngFor="let order of uniqueOrders"
        [value]="order?.label"
        (click)="onAdd(order)"
      >
        {{ order?.label }} ({{
          order?.count + ' ' + ((order?.count || 0) > 1 ? 'items' : 'item')
        }})
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
